"use client";

import { useEffect } from "react";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { useAppDispatch, useAppSelector } from "@/hooks/useStore";
import { getProgramList } from "@/store/controller/program.controller";
import { getIcon } from "./iconMap";
import { PROGRAM_THEME } from "./theme";

export function ProgramSection() {
  const dispatch = useAppDispatch();
  const programs = useAppSelector((state) => state.program.list);

  useEffect(() => {
    dispatch(getProgramList({}));
  }, [dispatch]);

  return (
    <section id="program" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-14">
          <span className="inline-block text-green-700 font-semibold text-sm uppercase tracking-widest mb-3">
            Keunggulan Kami
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-3">
            Program <span className="text-green-700">Unggulan</span>
          </h2>
          <div className="w-14 h-1 bg-yellow-400 rounded mx-auto mb-4" />
          <p className="text-gray-500 max-w-xl mx-auto">
            Kurikulum terpadu yang memadukan ilmu agama dan ilmu umum, dirancang untuk menghasilkan lulusan yang
            kompetitif dan berkarakter.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {programs.map((program) => {
            const Icon = getIcon(program.icon);
            const theme = PROGRAM_THEME[program.color_theme] ?? PROGRAM_THEME.green;
            return (
              <Link
                key={program.id}
                href={`/program/${program.slug}`}
                className={`p-6 rounded-2xl border ${theme.color} hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer`}
              >
                <div className={`w-12 h-12 rounded-xl ${theme.iconBg} flex items-center justify-center mb-4`}>
                  <Icon size={24} className="text-white" />
                </div>
                <div className="flex items-start justify-between mb-3">
                  <h3 className="font-bold text-gray-900 text-lg leading-snug flex-1">{program.title}</h3>
                  <span className={`text-xs font-bold px-2.5 py-1 rounded-full ml-2 flex-shrink-0 ${theme.tagColor}`}>
                    {program.tag}
                  </span>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">{program.description}</p>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            href="/program"
            className="inline-flex items-center gap-2 bg-green-700 hover:bg-green-800 text-white font-bold px-7 py-3.5 rounded-xl transition-all text-sm shadow-lg"
          >
            Lihat Semua Program <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
